export const SET_WARD_GROUPS = 'SET_WARD_GROUPS';
export const SET_USER_DRUG_GROUPS = 'SET_USER_DRUG_GROUPS';
export const DELETE_DRUG_GROUP = 'DELETE_DRUG_GROUP';
